import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { ActionCreators as PartenaireCreators } from "../../redux/Partenaire";
import Api, { IApi } from "../../services/Api";
import { Partenaire } from "../../services/Api/swagger";
import { getApiEndpoint } from "../../services/Config";

export const useGetPartenaireParCode = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const dispatch = useDispatch();

  return useMutation<Partenaire, any, string>(
    // @ts-ignore
    (params: string) => (api && api.getPartenaireParCode(params)) || undefined,
    {
      onSuccess: (data: Partenaire) => {
        dispatch(PartenaireCreators.getPartenaireParCode.failure(data));
      },
      onError: (error, variables) => {
        dispatch(PartenaireCreators.getPartenaireParCode.failure(error));
      },
    }
  );
};
